/**
 * Mascote da home em rodízio: troca a cada 2 dias, pela data LOCAL do visitante
 * (2026-10-23, pedido do operador: "por uns 2 dias é umas, depois é outra").
 *
 *   dias 0-1 → versão 1 · dias 2-3 → versão 2 · ... · depois volta para a 1
 *
 * POR QUE AUTOCONTIDA (mesmo truque de src/lib/ceu.ts)
 *
 * A home é gerada estática no build — sem data. Escolher só no React faria a
 * pessoa ver uma versão e depois outra no lugar. Então esta função vai
 * SERIALIZADA (toString) para um <script> no <head>, que roda antes do <body>
 * existir: marca html[data-mascote] (o CSS mostra só a versão certa) e cria o
 * preload da imagem certa. Não pode usar nada de fora: só os argumentos e os
 * globais do navegador.
 *
 * SÓ A VERSÃO DO DIA É BAIXADA. As quatro <img> ficam no HTML com
 * loading="lazy" e o CSS esconde três (display:none + lazy = o navegador não
 * busca). A visível chega rápido pelo preload criado aqui, com fetchpriority
 * alta e SEM crossorigin — o preload antigo do vite-react-ssg vinha com
 * crossorigin="" e o <img> sem, o que o navegador trata como pedidos
 * diferentes: a imagem da home era baixada duas vezes.
 *
 * ?mascote=1..4 força uma versão (para conferir sem esperar o calendário).
 */
export function aplicarMascoteDoDia(raiz: HTMLElement, agora: Date, urls: string[]): number {
  const total = urls.length;
  let indice = -1;

  const forcada = Number(new URLSearchParams(location.search).get("mascote"));
  if (forcada >= 1 && total >= forcada) indice = forcada - 1;

  if (indice === -1) {
    // dia do calendário LOCAL (meia-noite local), sem depender do fuso
    const dia = Math.floor(Date.UTC(agora.getFullYear(), agora.getMonth(), agora.getDate()) / 86400000);
    indice = Math.floor(dia / 2) % total;
  }

  raiz.setAttribute("data-mascote", String(indice + 1));

  if (!document.querySelector("link[data-mascote-preload]")) {
    const link = document.createElement("link");
    link.rel = "preload";
    link.setAttribute("as", "image");
    link.href = urls[indice];
    link.setAttribute("fetchpriority", "high");
    link.setAttribute("data-mascote-preload", "");
    document.head.appendChild(link);
  }
  return indice + 1;
}
